// Spinner.js
import React from 'react';
import './Spinner.css'; // Import the CSS file for styling

const Spinner = () => (
  <div className="spinner"></div>
);

export default Spinner;